/*
 * @Author: Src
 * @Date: 2024-07-16 14:09:28
 * @LastEditTime: 2025-08-08 13:34:57
 * @LastEditors: Src
 * @FilePath: /mobile-station/src/common/constant/index.ts
 * @Description: 头部注释配置模板
 */
import config from '@/config';

/** 登陆/注册 相关接口的url */
export const LOGIN_URL = [
    '/user/login', // 通过用户名、密码、或者验证码进行登陆
    '/user/register', // 手机号，密码注册接口
    '/verification-code', // 获取/刷新验证码
    'sms-verification-code', // 退出登录
  ];

/** API路径前缀 */
export const BASE_URL = `${config.API_URL}/api/v2`;

/** 购物车路径前缀 */
export const BASE_CAR_URL = `${config.CAR_URL}/api/u-car`;



/** BACKEND_URL 路径前缀 */
export const BASE_BACKEND_URL = `${config.BACKEND_URL}/api/rbac`;
